module.exports = __webpack_public_path__ + "static/stripe-integration-graphic-d7d44e103c0f95673ed658849fad12b3.svg";